var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 47.0878L100.843 1.73636C102.001 0.578785 103.531 0 105.054 0C108.257 0 111 2.56885 111 5.9385C111 7.46871 110.421 8.991 109.264 10.1565L63.9122 55.5L109.256 100.843C110.421 102.009 111 103.531 111 105.054C111 108.439 108.233 111 105.054 111C103.531 111 102.001 110.421 100.843 109.264L55.5 63.9201L10.1565 109.264C8.99893 110.421 7.46871 111 5.94643 111C2.76707 111 0 108.439 0 105.054C0 103.531 0.578784 102.009 1.74428 100.843L47.0878 55.5L1.73636 10.1565C0.578785 8.991 0 7.46871 0 5.9385C0 2.56885 2.74329 0 5.94643 0C7.46871 0 8.99893 0.578785 10.1565 1.73636L55.5 47.0878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.9659e90b8a8cd78936ae2485d0edeb69.svg";
export { ForwardRef as ReactComponent };